module.exports = __webpack_public_path__ + "img/logo.ed800dfd.svg";